import {
  PROPERTIES_STATUS_FOR_SLUG,
  TPROPERTIES_STATUS_FOR_SLUG
} from "@/src-refactor/modules/shared/model/const/realestate/property-status.const";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconPointFilled } from "@tabler/icons-react";

const MxCPropertyStatus = ({ title }: { title: string }) => {
  const status = PROPERTIES_STATUS_FOR_SLUG[title as TPROPERTIES_STATUS_FOR_SLUG];
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} container alignItems="center">
        <IconPointFilled
          style={{
            color: status.color,
            fontSize: 10
          }}
        />
        <MxTypography variant="overline" color="grey.700" children={status.name} />
      </Grid>
    </Grid>
  );
};

export default MxCPropertyStatus;
